<script setup>
import { ref } from 'vue'
import { DriverStore } from '../pinia/Driver.js'
import PremiumForm from './premiumForm.vue'
import benefits from '../configs/premium.json'

const Driver = DriverStore()
</script>

<template>
<div class="premiumCard">
    <v-container>
        <!-- Premium Status Card -->
        <div class="settings-card">
            <div class="settings-card-header">
                <div class="header-icon">
                    <v-icon size="28">mdi-star</v-icon>
                </div>
                <div class="header-content">
                    <h3 class="settings-title">Premium Membership</h3>
                    <p class="settings-subtitle" v-if="Driver.user.premium == '1'">
                        You are a Premium member - Thank you for your support!
                    </p>
                    <p class="settings-subtitle" v-else>
                        Unlock exclusive features and support the project
                    </p>
                </div>
            </div>

            <div class="settings-card-body">
                <!-- Premium Benefits -->
                <div class="setting-item">
                    <div class="setting-info full-width">
                        <div class="setting-label">
                            <v-icon size="20" class="mr-2">mdi-star-check</v-icon>
                            Premium Benefits
                        </div>
                        <div class="setting-description" v-if="Driver.user.premium == '1'">
                            The following benefits are active on your account
                        </div>
                        <div class="setting-description" v-else>
                            What you'll get with Premium membership
                        </div>
                        
                        <div class="benefits-list">
                            <div 
                                v-for="benefit in benefits" 
                                :key="benefit.title"
                                class="benefit-item"
                            >
                                <div class="benefit-icon">
                                    <v-icon size="24">{{ 'mdi-' + benefit.icone }}</v-icon>
                                </div>
                                <div class="benefit-content">
                                    <div class="benefit-title">{{ benefit.title }}</div>
                                    <div class="benefit-text" v-html="benefit.text"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Premium Form for non-premium users -->
                <div v-if="Driver.user.premium == '0'">
                    <v-divider class="my-4"></v-divider>
                    
                    <div class="setting-item">
                        <div class="setting-info full-width">
                            <div class="setting-label">
                                <v-icon size="20" class="mr-2">mdi-credit-card</v-icon>
                                Get Premium
                            </div>
                            <div class="setting-description">
                                Choose your payment method
                            </div>
                            <PremiumForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</div>
</template>

<style scoped>
.premiumCard {
    margin: 0;
    padding: 0;
}

.premiumCard .v-icon {
    color: currentColor;
    opacity: 1;
}

.settings-card {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
}

.settings-card-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    background: rgba(var(--v-theme-primary), 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.header-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: rgba(var(--v-theme-primary), 0.2);
    border-radius: 10px;
}

.header-icon .v-icon {
    color: rgb(var(--v-theme-primary));
}

.header-content {
    flex: 1;
}

.settings-title {
    margin: 0;
    font-size: 1.3em;
    font-weight: 600;
    color: rgb(var(--v-theme-primary));
}

.settings-subtitle {
    margin: 4px 0 0 0;
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.6);
}

.settings-card-body {
    padding: 24px;
}

.setting-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.setting-info {
    flex: 1;
}

.setting-info.full-width {
    width: 100%;
}

.setting-label {
    display: flex;
    align-items: center;
    font-size: 1em;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 6px;
}

.setting-label .v-icon {
    color: rgba(255, 255, 255, 0.9);
}

.setting-description {
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 16px;
}

.benefits-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.benefit-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
}

.benefit-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: rgba(var(--v-theme-primary), 0.15);
    border-radius: 8px;
    flex-shrink: 0;
}

.benefit-icon .v-icon {
    color: rgb(var(--v-theme-primary));
}

.benefit-content {
    flex: 1;
}

.benefit-title {
    font-size: 0.95em;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 4px;
}

.benefit-text {
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.4;
}
</style>
